/**
 * Grip aspect — Phase 5.1 PR 5.1.a.
 *
 * Wraps the existing `parseGrip` / `writeGrip` functions into the
 * `DynamicAspect<DynamicGrip>` contract. The wrapper is intentionally
 * thin: aspect.parse / aspect.write delegate verbatim so DXF fidelity
 * is preserved byte-for-byte against the pre-Phase-5.1 baseline.
 *
 * Registration happens at module load — `dxfBridge.dynamic.parser.ts`
 * (and `dxfBridge.dynamic.writer.ts`) import this module solely for
 * the side effect once the dispatcher is rewritten in a follow-up PR.
 *
 * For PR 5.1.a this module is **purely additive**: existing dispatch
 * paths in parser.ts / writer.ts continue to call `parseGrip` /
 * `writeGrip` directly. The aspect is verified through its unit test
 * (`dxfBridge.dynamic.aspect.grip.test.ts`) which proves the
 * delegation works end-to-end on a real grip OBJECT.
 */

import type { DynamicGrip } from "./dynamicBlockGrips";
import type { DynamicAspect } from "./dxfBridge.dynamic.aspect";
import { registerAspect } from "./dxfBridge.dynamic.aspect";
import { GRIP_CLASSES, parseGrip } from "./dxfBridge.dynamic.parser.grips";
import { writeGrip } from "./dxfBridge.dynamic.writer.grips";

export const GRIP_ASPECT: DynamicAspect<DynamicGrip, void, void> = {
  id: "grip",
  classes: GRIP_CLASSES,
  matches(canonicalType) {
    return GRIP_CLASSES.has(canonicalType);
  },
  parse(obj, canonicalType, _ctx) {
    return parseGrip(obj, canonicalType);
  },
  write(grip, _ctx) {
    return writeGrip(grip);
  },
};

registerAspect(GRIP_ASPECT);
